export enum Column {
    Actions,
    Text,
    Image,
    Date,
    Currency,
    Number,
    Boolean,
    Content
  }